import { useContext } from 'react';
import { SiteConfigContext } from '@bingads-webui-campaign-react/smart-page-context';
import { getImageMetaById } from '@bingads-webui-campaign-react/smart-component-util';

export const useImageMeta = ({
  imageId,
}) => {
  const { siteConfig } = useContext(SiteConfigContext);
  const image = getImageMetaById(siteConfig, imageId);

  return image;
};
